import { CM, MM } from "@pdfking/quantity"

export const FLAP_FOR_GLUE_SIZE = CM(2)
export const FLAP_FOR_CLOSE_SIZE = CM(4)
export const FLAP_SIZE = CM(1.5)
export const MIN_SHEET_SIZE = MM(0.5)
